import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';

import { Logger } from '@app/core/logger.service';

const log = new Logger('PipefyLogoutGuard');

@Injectable({
  providedIn: 'root'
})
export class PipefyLogoutGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): Observable<boolean> {
    if (location.hostname === 'sign.pipefy.com') {
      log.debug('This route was forbidden by Pipefy, redirecting to custom logout page...');
      this.router.navigate(['/401'], { replaceUrl: true });

      return of(false);
    }

    return of(true);
  }
}
